export default __webpack_public_path__ + "static/media/leg-icon-community.33904815.png";